import { useContext } from 'react'
import ContextStates from '../../context/ContextStates'
import axios from 'axios'
import { Url } from '../Url'
import { FaTrash, FaExclamationTriangle } from 'react-icons/fa'

const FDelCompra = () => {
    const { compraSelected, modify, setModify, setViewOpen, idUsuario } = useContext(ContextStates)

    const handleDelete = async () => {
        const formData = new FormData()
        formData.append('id', compraSelected.idcompra)
        formData.append('idusuario', idUsuario)
        try {
            const response = await axios({
                url: Url + 'api/delCompra.php',
                method: 'POST',
                data: formData,
            })
            console.log(response)
            let aux = modify + 1
            setModify(aux)
            setViewOpen(false)
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div className="w-full max-w-2xl mx-auto py-6 px-4 md:px-8 rounded-2xl bg-white">
            <div className="flex items-center justify-center gap-3 mb-6">
                <FaExclamationTriangle className="text-red-500 text-3xl animate-pulse" />
                <h2 className="text-center text-gray-800 text-2xl font-bold uppercase tracking-wider">
                    Eliminar Compra
                </h2>
            </div>

            <div className="bg-slate-50 border border-slate-200 rounded-xl p-5 mb-6 shadow-inner text-gray-700">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 text-sm md:text-base">
                    <div>
                        <p className="text-gray-500 font-medium">Proveedor</p>
                        <p className="text-gray-900 font-semibold text-lg">{compraSelected.proveedor || 'Sin Proveedor'}</p>
                    </div>
                    <div>
                        <p className="text-gray-500 font-medium">Fecha de Compra</p>
                        <p className="text-gray-900 font-semibold text-lg">{compraSelected.fecha}</p>
                    </div>
                </div>
                <div className="border-t border-slate-200 pt-4">
                    <p className="text-gray-500 font-medium">Monto Total</p>
                    <p className="text-red-600 font-bold text-2xl">
                        $ {parseFloat(compraSelected.total).toLocaleString("es-AR", { minimumFractionDigits: 2 })}
                    </p>
                </div>

                {typeof compraSelected.productos !== 'undefined' && compraSelected.productos.length > 0 && (
                    <div className="mt-6">
                        <h3 className="font-bold text-gray-800 mb-2 border-b pb-1 text-sm uppercase tracking-wider">
                            Productos a revertir del stock
                        </h3>
                        <div className="max-h-48 overflow-y-auto pr-2">
                            <table className="w-full text-left text-sm text-gray-600">
                                <thead>
                                    <tr className="text-xs font-semibold text-gray-500 uppercase">
                                        <th className="py-2">Cant.</th>
                                        <th className="py-2 px-2">Código</th>
                                        <th className="py-2">Descripción</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-slate-100">
                                    {compraSelected.productos.map((item, index) => (
                                        <tr key={index} className="hover:bg-slate-100/50">
                                            <td className="py-2 font-semibold text-red-600">-{item.cantidad}</td>
                                            <td className="py-2 px-2 font-mono text-gray-500">{item.codigo}</td>
                                            <td className="py-2 text-gray-800">{item.descripcion}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>

            <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-8">
                <p className="text-red-700 text-sm md:text-base text-center font-medium leading-relaxed">
                    ¿Estás seguro de que deseas eliminar esta compra? <br />
                    <span className="font-bold">Esta acción es irreversible</span> y restará las cantidades correspondientes del stock de cada producto listado arriba.
                </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-end">
                <button
                    type="button"
                    className="w-full sm:w-auto px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold rounded-xl transition-colors duration-200"
                    onClick={() => setViewOpen(false)}
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    className="w-full sm:w-auto px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded-xl shadow-lg shadow-red-600/20 hover:shadow-red-700/30 flex items-center justify-center gap-2 transition-all duration-200"
                    onClick={() => handleDelete()}
                >
                    <FaTrash size={16} />
                    Confirmar Eliminación
                </button>
            </div>
        </div>
    )
}

export default FDelCompra
